import React from 'react';
import cls from 'classnames';

import s from './ReverseIcon.scss';

function ReverseIcon({ w, h, className }) {
  return (
    <svg
      className={cls(s.icon, className)}
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        d="M7.8 8.8l1.7 1.7a.8.8 0 0 1-1 1l-3-3a.8.8 0 0 1 0-1l3-3a.8.8 0 0 1 1 1L7.8 7.3H16c1.7 0 2.8 1 2.8 2.7a.8.8 0 1 1-1.5 0c0-1-.4-1.3-1.3-1.3H7.8zm8.4 6.4l-1.7-1.7a.8.8 0 0 1 1-1l3 3a.8.8 0 0 1 0 1l-3 3a.8.8 0 0 1-1-1l1.7-1.8H8c-1.7 0-2.8-1-2.8-2.7a.8.8 0 1 1 1.5 0c0 1 .4 1.3 1.3 1.3h8.2z"
      />
    </svg>
  );
}

ReverseIcon.defaultProps = {
  w: 24,
  h: 24,
};

export default ReverseIcon;
